export default __webpack_public_path__ + "static/media/arihant1.7eaf00ed.mpeg";